export const aggregateYearlyData = (monthlyData: number[]): number[] => {
  const yearlyData = [];
  const monthsInYear = 12;
  yearlyData.push(monthlyData[0]);

  for (let i = monthsInYear; i < monthlyData.length; i += monthsInYear) {
    if (i + monthsInYear >= monthlyData.length) {
      yearlyData.push(monthlyData[monthlyData.length - 1]);
    } else {
      yearlyData.push(monthlyData[i]);
    }
  }
  return yearlyData;
};